module.exports = __webpack_public_path__ + "img/brick-or-cinder-block.e5b1dc31.png";